module.exports = __webpack_public_path__ + "img/right-arm.1675443d.png";